const videos = document.querySelectorAll( '.js-videoHolder' );

videos.forEach(videoholder => {

    const play = videoholder.querySelector( '.js-videoPlay' );
    const video = videoholder.querySelector( '.js-video' );

    if(video){

        play.addEventListener( 'click', ( e ) => {
            
            video.classList.add( '-show' );
            const iframe = video.querySelector( 'iframe' );
            const mp4 = video.querySelector( 'video' );

            if(iframe) {
                let src = iframe.getAttribute( 'src' )+'&autoplay=1&rel=0';
                iframe.setAttribute( 'src', src );
            } else if (mp4) {
                mp4.play();
            }

        });
    }

});